<template>
    <div class="plist_content">
        <div class="container">
            <slot name="sort"></slot>
            <!-- 商品列表 -->
			<template v-if="goods_list.length>0">
            <!-- <template v-if="!(goods_list == false)"> -->
                <el-row :gutter="20">
                    <el-col 
                        :span="list_span" 
                        v-for="(item, index) in goods_list"
                        :key="index">
                        <!-- 商品容器 -->
                        <div :class="[
                                displayMode?'plist_list_box01':'plist_list_box02',
                                {is_hover:list_hover === index}
                            ]"
                            @mouseenter="handleMouseMove(index)"
                            @mouseleave="handleMouseMove('')">
                            <!-- 图片 -->
                            <div class="plist_list_img">
                                <img-loading
                                    :src="item.goods_images[0]"
                                    :href="{name: 'pdetail', query:{id: item.goods_id},params:{cate_id:item.cat_id}}">
                                </img-loading>
                            </div>
                            <!-- 标题 -->
                            <div class="plist_list_title">
                                <router-link :to="{name: 'pdetail', query:{id: item.goods_id},params:{cate_id:item.cat_id}}">{{item.goods_name}}</router-link>
                            </div>
                            <!-- 价格 -->
                            <div class="plist_list_price" v-if="show_price && powerPrice">
                                <span>{{currency}}</span>
                                <span>{{item.shop_price}}</span>
                            </div>
                            <!-- 添加收藏 -->
                            <div v-if="power.includes(17) || power.includes(0) || power.includes(111)"
                                :class="[
                                    'plist_list_collection',
                                    {is_collection:item.collection>0}
                                ]">
                                <a href="javascript:;"
                                    @click="handleCollection(item)">
                                    <!-- 图标 -->
                                    <i class="glyphicon glyphicon-heart-empty"></i>
                                    <!-- 横向模式 -->
                                    <span v-show="!displayMode">
                                        {{item.collection>0?$t("message.plist.collection2"):$t("message.plist.collection1")}}
                                    </span>
                                </a>
                            </div>
                            <!-- 添加预购 -->
                            <div class="plist_list_add">
                                <!-- 加入购物车 -->
                                <el-button
                                    @click="addCart(item.goods_id, false)"
                                    :class="['plist_list_add_btn',{'el-button--text':displayMode},
                                    {'el-button--primary':!displayMode}]">
                                    <i class="glyphicon glyphicon-shopping-cart"></i>
                                    <!-- 标题 -->
                                    <span>{{$t("public.shoppingCart")}}</span>
                                </el-button>
                                <b v-if="displayMode">|</b>
                                <!-- 加入报价车 -->
                                <el-button
                                    @click="addCart(item.goods_id, true)"
                                    :class="['plist_list_add_btn',{'el-button--text':displayMode},
                                    {'el-button--primary':!displayMode}]">
                                    <i class="glyphicon glyphicon-usd"></i>
                                    <!-- 标题 -->
                                    <span>{{$t("public.quoteCart")}}</span>
                                </el-button>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <!-- 分页条 -->
                <slot name="pagination"></slot>
            </template>
            <template v-else>
                <div class="plist_content_nothing">
                    {{$t("message.plist.nothing")}}
                </div>
            </template>
        </div>
        <!-- 属性选择模态框 -->
        <get-attr :url="quote_url"></get-attr>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'

export default {
    data() {
        return {
            list_span: 6, // 单个商品占行位置
            list_hover: null, // 是否悬停
            
            quote_url: ""
        }
    },
    props: {
        displayMode: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        ...mapState({
            islogin: state => state.user.islogin,
            goods_list: state => state.goods.goods_list,
			power: state => state.user.power,
            // 
            currency: state => state.currency,
            show_price: state => state.show_price
        }),
        ...mapGetters([
            'powerPrice',
        ])
    },
    components: {
        imgLoading: () => import("@/components/imgLoading"),
        getAttr: () => import("@/components/getAttr"),
    },
    watch: {
        displayMode: {
            handler: function (value) {
                this.list_span = value? 6: 24
            },
            immediate: true
        }
    },
    methods: {
        ...mapMutations([
            "handleDialog",
            "changePlistCollection"
        ]),
        ...mapActions([
            "getPlist",
            "getPdetail",
            "requestCollection"
        ]),
        handleMouseMove(arg){ // 鼠标悬停状态
            if(arg!==""){
                this.list_hover = arg;
            }else{
                this.list_hover = null;
            }
        },
        handleCollection(goods){ // 收藏操作
            if(this.islogin){
                let { goods_id, goods_sn, goods_name } = goods;
                this.requestCollection({
                    goods_id,
                    goods_sn,
                    goods_name
                }).then((res) => {
                    if(res == 1){
                        this.changePlistCollection({
                            id: goods_id,
                            status: 1
                        })
                        this.$message({
                            showClose: true,
                            message: this.$t("message.plist.collection3"),
                            type: 'success'
                        })
                    }else if(res == 3){
                        this.changePlistCollection({
                            id: goods_id,
                            status: 0
                        })
                        this.$message({
                            showClose: true,
                            message: this.$t("message.plist.collection4"),
                            type: 'success'
                        })
                    }
                })
            }else{
                this.$confirm(this.$t("public.notLogin"), {
                    confirmButtonText: this.$t("public.goLogin"),
                    cancelButtonText: this.$t("public.cancelBtn"),
                    type: 'warning',
                    center: true
                }).then(() => {
                    this.$router.push('/login');
                }).catch(() => {});
            }
        },
        addCart(id, need_url){ // 添加购物车或报价车函数
            // 判断是否登录
            if(!this.islogin){
                this.$confirm(this.$t("public.notLogin"), "", {
                    confirmButtonText: this.$t("public.goLogin"),
                    cancelButtonText: this.$t("public.cancelBtn"),
                    type: 'warning',
                    center: true
                }).then(() => {
                    this.$router.push('/login');
                }).catch(() => {});
                return
            }
            // 判断是否是报价车
            this.quote_url = need_url? "/index/detail/quote_cart": "/index/detail/cart";
            this.getPdetail(id); // 获取商品信息
            this.handleDialog(true); // 打开模态框
        }
    }
}
</script>

<style scoped>
/*  */
.plist_content .el-col{
    margin-bottom: 10px;
}


/* 组件盒子 */
.plist_content{
    margin-bottom: 50px;
}
/* ************ 九宫格布局 ************************************************** */
/* 商品列表盒子 */
.plist_list_box01{
    position: relative;
    width: 100%;
    height: 360px;
    text-align: center;
    background-color: #fff;
}
/* 图片盒子 */
.plist_list_box01>.plist_list_img{
    width: 100%;
    height: 250px;
    padding: 30px 20px;
}
/* 标题 */
.plist_list_box01>.plist_list_title{
    padding: 0 20px;
    margin-bottom: 25px;
}
.plist_list_box01>.plist_list_title>a{
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    color: #333
}
.plist_list_box01>.plist_list_title>a:hover{
    color: #ff6700;
}
/* 价格 */
.plist_list_box01>.plist_list_price{
    color: #ff6700;
}
.plist_list_box01>.plist_list_price> span + span{
    margin-left: 10px;
    font-size: 16px;
    font-weight: bold;
}
/* 收藏--基础样式 */
.plist_list_box01>.plist_list_collection{
    position: absolute;
    top: 5px;
    right: 5px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: #909399;
    opacity: 0;
    transition: all 0.2s linear;
    z-index: -1;
}
.plist_list_box01>.plist_list_collection>a{
    position: absolute;
    top: 50%;
    left:50%;
    transform: translate(-50%,-50%);
    display: block;
    color: #fff;
}
.plist_list_box01>.plist_list_collection>a>i{
    font-size: 30px;
    line-height: normal;
}
/* 收藏--已收藏样式 */
.plist_list_box01>.is_collection{
    background-color: transparent !important;
    opacity: 1;
    z-index: 100;
}
.plist_list_box01>.is_collection>a{
    color: #ff6700;
}
/* 添加区域 */
.plist_list_box01>.plist_list_add{
    position: absolute;
    bottom:0;
    width: 100%;
    height: 60px;
    text-align: left;
    border-top: 1px solid #333;
    background-color: #fff;
    opacity: 0;
    transition: all 0.2s linear;
    z-index: -1;
}
.plist_list_box01 .plist_list_add_btn{
    width: 49%;
    color: #909399
}
.plist_list_box01 .plist_list_add_btn:hover{
    color: #ff6700;
}
.plist_list_box01 .plist_list_add_btn .glyphicon{
    display: block;
    margin-bottom: 5px;
}
/* 鼠标悬停 */
.plist_list_box01.is_hover>.plist_list_collection{
    z-index: 3;
    opacity: 0.8;
}
.plist_list_box01.is_hover>.plist_list_collection:hover{
    background: #ff6700;
}
.plist_list_box01.is_hover>.plist_list_add{
    z-index: 3;
    opacity: 0.8;
}

/* ************ 横向布局 ************************************************** */
.plist_list_box02{
    position: relative;
    height: 121px;
    background-color: #fff;
    border-bottom: 1px solid #e0e0e0;
    transition: box-shadow 0.5s linear;
}
.plist_list_box02>div{
    display: inline-block;
    vertical-align: middle;
    margin-right: 30px;
}
/* 图片样式 */
.plist_list_box02>.plist_list_img{
    width: 120px;
    height: 120px;
}
/* 标题样式 */
.plist_list_box02>.plist_list_title{
    width: 350px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.plist_list_box02>.plist_list_title>a{
    color: #333;
    font-size: 18px;
}
.plist_list_box02>.plist_list_title>a:hover{
    color: #ff6700
}
/* 价格 */
.plist_list_box02>.plist_list_price{
    width: 170px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.plist_list_box02>.plist_list_price>span{
    color: #ff6700;
    font-size: 18px; 
}
.plist_list_box02>.plist_list_price>span + span{
    margin-left: 10px;
    font-size: 28px;
    font-weight: bold;
}
/* 收藏 */
.plist_list_box02>.plist_list_collection{
    position: absolute;
    top: 50%;
    right: 0;
    transform: translate(-50%,-50%)
}
.plist_list_box02>.plist_list_collection>a{
    color: #333
}
.plist_list_box02>.plist_list_collection>a>i{
    vertical-align: middle;
    margin-right: 5px;
    font-size: 25px;
}
/* 已收藏样式 */
.plist_list_box02>.is_collection{
    margin-right: 0;
}
.plist_list_box02>.is_collection>a{
    color: #ff6700
}
/* 添加区域 */
.plist_list_box02 .plist_list_add_btn{
    margin-left: 20px;
}
.plist_list_box02 .plist_list_add_btn .glyphicon{
    margin-right: 5px;
}
/* 鼠标悬停 */
.plist_list_box02.is_hover{
    box-shadow:0 5px 15px rgba(0,0,0,0.2);
}


/* 暂无商品 */
.plist_content_nothing{
    width: 100%;
    height: 500px;
    line-height: 500px;
    text-align: center;
    font-size: 30px;
    color: #b0b0b0;
    border: 1px solid #ddd;
    box-shadow: 0px 0px 20px 5px #888888;
}

/* ***************************** 媒体查询 ******************************** */
/*中屏幕下样式*/
@media screen and (min-width: 992px) and (max-width: 1199px){
    /* 九宫格--添加按钮样式 */
    .plist_list_box01 .plist_list_add_btn{
        width: 48%;
    }
    /* 横向布局 */
    .plist_list_box02>div{
        margin-right: 20px;
    }
    /* 横向布局--标题样式 */
    .plist_list_box02>.plist_list_title{
        width: 200px;
    }
}
</style>
